export default {
  namespaced: true,
  state: {
    baseURL: getBaseURL(),
  },
  getters: {
    parseUrl: (state) => ({ baseURL, query, url }) => {
      baseURL = baseURL || state.baseURL
      const href = new URL(baseURL + url)
      const search = new URLSearchParams(query)
      href.search = search
      return href
    },
    parseHeaders: (state, getters, rootState, rootGetters) => ({ headers }) => {
      const base = {
        'Content-Type': 'application/json',
      }
      if (rootGetters['auth/token']) {
        base['Authorization'] = `Bearer ${rootGetters['auth/token']}`
      }
      return { ...base, ...headers }
    },
  },
  actions: {
    async fetch ({ getters, dispatch }, opts) {
      const {
        baseURL,
        url,
        query,
        headers,
        ...config
      }  = opts

      config.headers = getters.parseHeaders({ headers })

      const href = getters.parseUrl({ baseURL, url, query })
      const response = await fetch(href, config)

      if (response.status == 401) {
        await dispatch('auth/logout', null, { root: true })
        return {}
      }
      if (response.status < 200 || response.status >= 300) {
        throw new ResponseException(response)
      }

      let data
      if (isJson(response)) {
        data = await response.json()
      }
      return { ...response, data }
    },
    async get ({ dispatch }, opts) {
      return await dispatch('fetch', {
        ...opts,
        method: 'GET',
      })
    },
    async post ({ dispatch }, { data, ...opts }) {
      return await dispatch('fetch', {
        ...opts,
        method: 'POST',
        body: JSON.stringify(data),
      })
    },
    async put ({ dispatch }, { data, ...opts }) {
      return await dispatch('fetch', {
        ...opts,
        method: 'PUT',
        body: JSON.stringify(data),
      })
    },
    async delete ({ dispatch }, opts) {
      return await dispatch('fetch', {
        ...opts,
        method: 'DELETE',
      })
    },
  },
}

function isJson (response) {
  const type = response.headers.get('Content-Type')
  if (!type) {
    return false
  }
  return type.includes('application/json')
}

export class ResponseException extends Error {
  constructor (response) {
    super('')
    this.response = response
  }
}
export class UnauthorizedException extends Error {
  constructor (response) {
    super('')
    this.response = response
  }
}

function getBaseURL () {
  let url = process.env.VUE_APP_BASE_API
  const isUrl = /^http/.test(url)
  if (!isUrl) {
    url = location.origin + url
  }
  return url
}
